import { useState } from 'react';
import { addressLines } from '@/mocks/downloadData';

export default function AddressList() {
  const [copied, setCopied] = useState<string | null>(null);

  const handleCopy = async (host: string) => {
    try {
      await navigator.clipboard.writeText(host);
    } catch {
      // clipboard may be unavailable, still give visual feedback
    }
    setCopied(host);
    window.setTimeout(() => setCopied((prev) => (prev === host ? null : prev)), 1800);
  };

  return (
    <section id="address" className="w-full bg-background-100 px-4 md:px-8 py-14 md:py-20 scroll-mt-20">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8">
          <span className="inline-flex items-center gap-1.5 text-primary-600 text-xs font-medium tracking-wide">
            <i className="ri-links-line"></i>
            ADDRESS
          </span>
          <h2 className="mt-2 font-heading text-3xl md:text-4xl text-foreground-950 tracking-wide">
            最新地址与备用线路
          </h2>
          <p className="mt-3 max-w-2xl text-foreground-600 text-sm md:text-base leading-relaxed">
            换地址不迷路。当某个入口无法打开时，回到这里切换到标注为「可用」的其他线路即可继续访问。
          </p>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          <div className="hidden md:grid grid-cols-12 gap-4 px-5 py-3 bg-background-200/60 text-xs text-foreground-600">
            <div className="col-span-3">线路名称</div>
            <div className="col-span-4">访问地址</div>
            <div className="col-span-2">节点</div>
            <div className="col-span-1">速度</div>
            <div className="col-span-2 text-right">状态 / 操作</div>
          </div>

          <ul className="divide-y divide-background-200">
            {addressLines.map((line) => {
              const available = line.status === 'available';
              return (
                <li key={line.host} className="px-5 py-4 hover:bg-background-100 transition-colors">
                  <div className="md:grid md:grid-cols-12 md:gap-4 md:items-center">
                    <div className="md:col-span-3">
                      <div className="flex items-center gap-2">
                        <span className="text-foreground-950 text-sm font-medium">{line.name}</span>
                      </div>
                      <div className="mt-1 text-foreground-500 text-xs">{line.note}</div>
                    </div>

                    <div className="md:col-span-4 mt-2 md:mt-0 flex items-center gap-2">
                      <i className="ri-global-line text-foreground-400"></i>
                      <span className="text-foreground-700 text-sm break-all font-mono">{line.host}</span>
                    </div>

                    <div className="md:col-span-2 mt-2 md:mt-0 text-foreground-600 text-xs">
                      <span className="inline-flex items-center gap-1 md:hidden text-foreground-400 mr-1">节点</span>
                      {line.region}
                    </div>

                    <div className="md:col-span-1 mt-2 md:mt-0 text-foreground-600 text-xs">{line.speed}</div>

                    <div className="md:col-span-2 mt-3 md:mt-0 flex md:justify-end items-center gap-2">
                      <span
                        className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs ${
                          available
                            ? 'bg-secondary-100 text-secondary-900'
                            : 'bg-accent-100 text-accent-900'
                        }`}
                      >
                        <span
                          className={`w-1.5 h-1.5 rounded-full ${
                            available ? 'bg-secondary-500' : 'bg-accent-500'
                          }`}
                        ></span>
                        {available ? '可用' : '维护中'}
                      </span>
                      <button
                        type="button"
                        onClick={() => handleCopy(line.host)}
                        className="inline-flex items-center gap-1 px-3 py-1.5 rounded-md border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-600 text-xs transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <i className={copied === line.host ? 'ri-check-line' : 'ri-file-copy-line'}></i>
                        {copied === line.host ? '已复制' : '复制'}
                      </button>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>

        <p className="mt-4 flex items-start gap-2 text-foreground-500 text-xs leading-relaxed">
          <i className="ri-information-line mt-0.5"></i>
          页面地址会不定期更新，建议收藏本页以便随时获取最新入口。线路可用状态以实际访问情况为准。
        </p>
      </div>
    </section>
  );
}